import store from '@/store'
import { getCourseFullName } from '@shared/utils/courses'

const CUSTOM_VALUES_GETTERS = {
  departments: id => store.getters['departments/departmentDisplayName'](id),
  startTerm: (term) => {
    if (!term || !term.id) return ''
    return store.getters['termDisplayName'](store.getters['termById'](term.id))
  },
  endTerm: (term) => {
    if (!term || !term.id) return ''
    return store.getters['termDisplayName'](store.getters['termById'](term.id))
  },
  aliases: aliases =>
    aliases.map(
      ({ subjectCode, courseNumber }) => `${subjectCode}${courseNumber}`
    ),
  crossListedCourses: courses =>
    (courses || []).map(({ entityId, effectiveStartDate }) => {
      const course = store.getters[
        'curriculumCourses/cmCourseByCourseGroupIdAndEffectiveStartDate'
      ](entityId, effectiveStartDate)
      return Object.keys(course).length
        ? `${course.subjectCode}${course.courseNumber} ${course.name}`
        : entityId
    }),
  // TODO: Test
  courseEquivalencies: courses =>
    (courses || []).map(({ courseGroupId, effectiveStartDate }) => {
      const course = store.getters[
        'curriculumCourses/cmCourseByCourseGroupIdAndEffectiveStartDate'
      ](courseGroupId, effectiveStartDate)
      return Object.keys(course).length
        ? getCourseFullName(course)
        : courseGroupId
    }),
}

const FIELDS_WITH_CUSTOM_VALUES = Object.keys(CUSTOM_VALUES_GETTERS)

export default function useFieldCustomValue () {
  function getCustomValue (fieldId, fieldValue) {
    if (FIELDS_WITH_CUSTOM_VALUES.includes(fieldId)) {
      return CUSTOM_VALUES_GETTERS[fieldId](fieldValue)
    }

    return fieldValue
  }

  return {
    getCustomValue,
  }
}
